import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
import { Skeleton } from '@fortem-monorepo/react-ui';
import { WidgetHeaderWithQuery } from './WidgetHeaderWithQuery';
/**
 * Top level component.
 */
export const Widget = ({ exposed = false, className, children, ...props }) => {
    return (_jsx("div", { className: cn('relative flex flex-col w-full overflow-hidden', {
            ['border rounded-md shadow-[0_0_10px_3px_rgb(from_gray_r_g_b/8%)]']: !exposed,
        }, className), ...props, children: children }));
};
/**
 * The content of the widget, wrapps charts and tables primarily.
 */
export const WidgetContent = ({ loading, className, children }) => {
    return (_jsxs("div", { className: cn('relative w-full h-full', className), children: [loading && (_jsxs("div", { className: 'absolute w-full h-full', children: [_jsx("div", { className: "z-10 absolute top-0 left-0 w-full h-full bg-white" }), _jsx(Skeleton, { className: 'z-10 absolute top-0 left-0 w-full h-full rounded-none' })] })), children] }));
};
export const GridWidget = ({ query, title, className, children }) => {
    return (_jsxs(Widget, { className: cn(className), children: [_jsx(WidgetHeaderWithQuery, { title: title, query: query }), _jsx(WidgetContent, { className: 'h-full', loading: query?.isLoading, children: children })] }));
};
